export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const EDIT_USER = 'EDIT_USER';
export const CREATE_USER = 'CREATE_USER';
export const LOAD_USERS_LIST = 'LOAD_USERS_LIST';
export const LOAD_USERS_PROJECTS = 'LOAD_USERS_PROJECTS';
export const EDIT_BALANCE = 'EDIT_BALANCE';
export const CHANGE_USER_WORK_STATUS = 'CHANGE_USER_WORK_STATUS';
export const EDIT_SUPPORT_LIMIT = 'EDIT_SUPPORT_LIMIT';
export const RESET_SUPPORT_LIMIT = 'RESET_SUPPORT_LIMIT';
export const GET_2FA_DATA = 'GET_2FA_DATA';
export const ENABLE_2FA = 'ENABLE_2FA';
export const DISABLE_2FA = 'DISABLE_2FA';
export const LOAD_BALANCE = 'LOAD_BALANCE';
export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const CHANGE_SESSION = 'CHANGE_SESSION';
export const DELETE_SESSION = 'DELETE_SESSION';
